const meta = {
  'add-agent-to-fleet': 'Add agents to a fleet',
  'add-files-to-fleet': 'Add files to a fleet',
  agent: 'Agent types',
};

export default meta;
